const ContentWrapper = ({children}) => {
    return <div style={{
        height: "766px", width: "1620px"
    }} className="d-flex justify-content-center mx-0 mt-2 overflow-hidden live-v2">
        {children}
    </div>
}
export default ContentWrapper;